export default __webpack_public_path__ + "static/media/IMG_2270cropped.bafa3221.jpeg";